import { Grid, Dialog, DialogContent, DialogTitle, Button } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { FichajeCard } from './FichajeCard';
import { getFichajesUsuario } from '../../services/apis';
import { mesName } from '../../utils/utils';
import { SelectorMes } from '../../utils/componentes-utiles/SelectorMes';
import { SelectorYear } from '../../utils/componentes-utiles/SelectorYear';

import DialogCorregirFichaje from "./DialogCorregirFichaje";

export const DialogFichajesUsuario = ({ open, onClose, usuarioId,  esadmin}) => {

    const [fichajes, setFichajes] = useState([]);
    const [loaded, setLoaded] = useState(false);

    const [nombreMes, setNombreMes] = useState('');
    const [mes, setMes] = useState(new Date().getMonth() + 1);
    const [nombre, setNombre] = useState(" ");
    const [yearSelected, setYearSelected] = useState(new Date().getFullYear());
    const [years, setYears] = useState([]);

    const [openNuevoCorrector, setOpenNuevoCorrector] = useState(false);

    const fichajesUsuario = async (id) => {
        try {
            const response = await getFichajesUsuario(mes, yearSelected, id);
            setFichajes(response.data.fichajes);
            setNombre(response.data.nombre.nombre);
            setYears(response.data.years);
            setLoaded(true);
        } catch (error) {
            console.error("Error al obtener fichajes:", error);
        }
    };

    useEffect(() => {
        if (open) {
            fichajesUsuario(usuarioId);
            setNombreMes(mesName(mes));
        }
    }, [open]);

    useEffect(() => {
        fichajesUsuario(usuarioId);
        setNombreMes(mesName(mes));
    }, [mes, yearSelected]);

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="xl">
            <DialogTitle sx={{ mb: -2 }}>
                {/* Puedes añadir aquí un SubHeader si quieres */}
            </DialogTitle>

            <DialogContent>
                <Grid container direction="row" justifyContent="space-between" padding="1em">

                    {/* === TÍTULO + BOTÓN === */}
                    <Grid
                        container
                        xs={12}
                        sm={6}
                        justifyContent="flex-start"
                        alignItems="center"
                        gap={2}
                    >
                        <h3>Fichajes de {nombre ?? ""}</h3>

                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => setOpenNuevoCorrector(true)}
                        >
                            Añadir fichaje corrector
                        </Button>
                    </Grid>

                    {/* === SELECTOR MES === */}
                    <Grid container xs={6} sm={4} md={3} justifyContent="center">
                        {mes && <SelectorMes mes={mes} setMes={setMes} />}
                    </Grid>

                    {/* === SELECTOR AÑO === */}
                    <Grid container xs={6} sm={2} md={2} justifyContent="center">
                        {years.length >= 1 && (
                            <SelectorYear
                                years={years}
                                yearSelected={yearSelected}
                                setYearSelected={setYearSelected}
                            />
                        )}
                    </Grid>

                    {/* === MENSAJE SI NO HAY FICHAJES === */}
                    {fichajes.length <= 0 && (
                        <Grid container xs={12} justifyContent="center" alignItems="center">
                            <strong>Todavía no hay fichajes</strong>
                        </Grid>
                    )}

                    {/* === LISTA DE FICHAJES === */}
                    {fichajes.map((fichaje, index) => (
                        <FichajeCard
                            fichaje={fichaje}
                            nombreMes={nombreMes}
                            key={index}
                            fichajesUsuario={fichajesUsuario}
                            usuarioId={usuarioId}
                            esadmin={esadmin}
                        />
                    ))}
                </Grid>
            </DialogContent>

            {/* === DIALOG PARA NUEVO FICHAJE CORRECTOR === */}
            <DialogCorregirFichaje
                open={openNuevoCorrector}
                onClose={() => {
                    setOpenNuevoCorrector(false);
                    fichajesUsuario(usuarioId); // Refrescar lista al cerrar
                }}
                fichaje={null}            // Se interpreta como "crear nuevo corrector"
                fichajesUsuario={fichajesUsuario}
                usuarioId={usuarioId}
            />
        </Dialog>
    );
};
